import script from "./BirthdayPolicyAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayPolicyAdminView.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayPolicyAdminView.vue?vue&type=style&index=0&id=23d629eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d629eb"]])

export default __exports__